import React from "react";
import type { ButtonProps, ButtonSize, ButtonType } from "./Button.types";

const VARIANT_CLASSES: Record<ButtonType, string> = {
    primary: "bg-primary-700 text-white",
    secondary: "bg-gray-500 text-white",
    success: "bg-green-500 text-white",
    info: "bg-sky-500 text-white",
    danger: "bg-red-500 text-white",
    warning: "bg-amber-500 text-white",
    transparent: "bg-transparent text-violet-700",
};

const HOVER_CLASSES: Record<ButtonType, string> = {
    primary: "hover:bg-primary-800",
    secondary: "hover:bg-gray-600",
    success: "hover:bg-green-600",
    info: "hover:bg-sky-600",
    danger: "hover:bg-red-600",
    warning: "hover:bg-amber-600",
    transparent: "hover:text-violet-900",
};

const SIZE_CLASSES: Record<ButtonSize, string> = {
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg",
    xl: "text-xl",
};

const Button: React.FC<ButtonProps> = (
    {
        onClick,
        label,
        icon,
        type = "primary",
        rounded = false,
        size = "md",
        iconPosition = "left",
        className = "",
        style,
        disabled = false
    }) => {
    const variantClass = VARIANT_CLASSES[type];
    const hoverClass = disabled ? "" : HOVER_CLASSES[type];
    const roundClass = rounded ? 'rounded-full' : 'rounded-md';
    const sizeClass = SIZE_CLASSES[size];
    const disabledClass = disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer";

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={`px-2 py-2 ${roundClass} ${variantClass} ${hoverClass} ${sizeClass} flex items-center whitespace-nowrap ${disabledClass} ${className}`}
            style={style}
        >
            {icon && iconPosition === "left" && <span className={label ? "mr-" : ""} aria-hidden="true">{icon}</span>}
            {label && <span className={`inline-block mx-2`}>{label}</span>}
            {icon && iconPosition === "right" && <span className={label ? "ml-" : ""} aria-hidden="true">{icon}</span>}
        </button>
    );
};

export default Button;
